import classNames from 'classnames';
import React from 'react';
import Style from 'styles/components/cmp.module.scss';
import useScrollAnimation from 'hooks/useScrollAnimation';

const Comparison = () => {
  const [sectionRef, isVisible] = useScrollAnimation(0.1);

  return (
    <section ref={sectionRef} className={classNames(Style.cmp, { [Style.cmpVisible]: isVisible })}>
      <span className={Style.eyebrow}>Compare</span>
      <h2 className={Style.cmp__title}>他社サービスとの比較</h2>
      <div className={Style.cmp__subTitle}>
        当社の独自調査による比較となります（2026年3月時点）。
      </div>

      <div className={Style.pricingTable}>
        <table>
          <thead>
            <tr>
              <th colSpan={2}></th>
              <th className={Style.headerComachi}>
                comachicart<br />スタートアッププラン
              </th>
              <th className={Style.headerOther}>他社サービス<br />A</th>
              <th className={Style.headerOther}>他社サービス<br />B</th>
              <th className={Style.headerOther}>他社サービス<br />C</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowSpan={3}>カートシステム</th>
              <td className={Style.itemLabel}>初期費用</td>
              <td className={Style.valueComachi}>0円</td>
              <td className={Style.valueOther}>0円</td>
              <td className={Style.valueOther}>3,300円</td>
              <td className={Style.valueOther}>0円</td>
            </tr>
            <tr>
              <td className={Style.itemLabel}>月額費用</td>
              <td className={Style.valueComachi}>0円</td>
              <td className={Style.valueOther}>0円</td>
              <td className={Style.valueOther}>4,950円</td>
              <td className={Style.valueOther}>4,850円</td>
            </tr>
            <tr>
              <td className={Style.itemLabel}>システム利用料</td>
              <td className={Style.valueComachi}>2.5%</td>
              <td className={Style.valueOther}>3%</td>
              <td className={Style.valueOther}>0円</td>
              <td className={Style.valueOther}>2%<sup>*5</sup></td>
            </tr>
            <tr>
              <th rowSpan={3}>クレジットカード</th>
              <td className={Style.itemLabel}>月額費用</td>
              <td className={Style.valueComachi}>0円</td>
              <td className={Style.valueOther}>0円</td>
              <td className={Style.valueOther}>40円</td>
              <td className={Style.valueOther}>0円</td>
            </tr>
            <tr>
              <td className={Style.itemLabel}>
                売上処理量<br />
                <span className={Style.itemSub}>(トランザクション費用)</span>
              </td>
              <td className={Style.valueComachi}>0円</td>
              <td className={Style.valueOther}>0円</td>
              <td className={Style.valueOther}>0円</td>
              <td className={Style.valueOther}>0円</td>
            </tr>
            <tr>
              <td className={Style.itemLabel}>決済手数料</td>
              <td className={Style.valueComachi}>3.2%</td>
              <td className={Style.valueOther}>3.6%</td>
              <td className={Style.valueOther}>3.4%</td>
              <td className={Style.valueOther}>3.55%、3.9%<sup>*6</sup></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className={Style.notice}>
        <div>*5 C社が提供する決済サービスを利用していない場合となります。</div>
        <div>*6 利用されるクレジットカード会社によって手数料が異なります。</div>
      </div>
    </section>
  );
};

export default Comparison;
